module.exports = __webpack_public_path__ + "img/park-bgbottom2.47ef52fb.png";